import { Outlet, useParams } from 'react-router-dom';
import NotFoundPage from '@/pages/NotFoundPage';

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function RestaurantRouteGuard() {
  const { restaurantUuid } = useParams();
  if (!restaurantUuid || !UUID_RE.test(restaurantUuid)) {
    return <NotFoundPage />;
  }
  return <Outlet />;
}
